import { render } from "./AdminWebsite.vue?vue&type=template&id=26148e5d"
import script from "./AdminWebsite.vue?vue&type=script&lang=js"
export * from "./AdminWebsite.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__